import { Component, OnInit, Input } from '@angular/core';
import { CheckrService } from '../../../shared/services/checkr.service';
import { LocalUserService } from '../../services/localUser';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'caseBackground',
  templateUrl: './case-background.component.html',
  styleUrls: ['./case-background.component.scss']
})
export class CaseBackgroundComponent implements OnInit {

  @Input() reportId: ''
  screenInfo: any;
  userDetails;
  screeningData: any;
  packages = [];
  existingPackages = [];
  loading: boolean = false
  backgroundReport: {};

  showAddresses: boolean = false;
  error: string;
  constructor(
    public checkrService: CheckrService,
    public localUser: LocalUserService,
    public snackBar: MatSnackBar,

  ) {
    this.userDetails = this.localUser.getUser()
    if (this.userDetails.role === 'GUARDIAN' && this.reportId == null) {
      this.reportId = this.userDetails.background_report_id
     // this.getBackgroundDetails()

    }
    this.getScreenData()
    this.getAllPackages()
  }
  ngOnChanges() {
    if (this.reportId) {
      this.getBackgroundDetails()
    }

  }
  // ngAfterViewInit() {

  // }

  ngOnInit() {

  }
  getScreenData() {
    this.screenInfo = this.checkrService.getCheckrCall()
  }

  getAllPackages() {
    this.packages = this.checkrService.getAllPackages()

  }
  getBackgroundDetails() {
    this.loading = true
    this.checkrService.getChekr(this.reportId)
      .subscribe(item => {
        this.backgroundReport = item;
        for (let item of this.packages) {
          item.data = this.backgroundReport[item.code]
          if (item.data) {
            this.existingPackages.push(item)
          }
        }
        this.loading = false
      }, error => {
        this.loading = false;
        this.error = 'Can not fetch Background details';
        this.snackBar.open(this.error, '', {
          duration: 2000,
        });
      });
  }

  getBlockColor(status) {
    if (status){
      if(status == 'clear' || status == 'complete'){
        return'#bde2f3';
      }else{
        return '#f5cce0';
      }
    }else {
      return 'lightgray';
    }
  }
  gettextColor(status) {
    if (status)
      return status == 'clear' ? '#039be5' : 'red';
    else {
      return 'gray';
    }
  }

  getChipColor(status) {
    if (status)
      return status == 'clear' ? '#039be5' : 'red';
    else {
      return 'gray';
    }
  }
  getBlockBorder(status) {
    if (status)
      return status == 'clear' ? '1px solid #039be5' : '1px solid red';
    else {
      return '1px solid gray';
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/main/shared/components/case-background/case-background.component.ts